import {Component, OnInit, Inject, AfterViewInit, ChangeDetectorRef} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { FormBuilder } from '@angular/forms';
import { ABW_MAT_DATATABLE_VIEWMODE } from 'src/app/shared/abw-mat-datatable/abw-mat-datatable.component';

@Component({
    selector: 'app-datasource-datas-selection-dialog',
    templateUrl: './datasource-datas-selection-dialog.component.html',
    styleUrls: ['./datasource-datas-selection-dialog.component.scss']
})
export class DatasourceDatasSelectionDialogComponent implements OnInit, AfterViewInit {
    datas: any;
    loading = false;
    selection: any[] = [];
    primaryKey: string;
    datatableViewMode = ABW_MAT_DATATABLE_VIEWMODE.READONLY;
    label: string;

    constructor(
        public dialogRef: MatDialogRef<DatasourceDatasSelectionDialogComponent>,
        private _formBuilder: FormBuilder,
        private _dialog: MatDialog,
        private _cdf: ChangeDetectorRef,
        @Inject(MAT_DIALOG_DATA) public data: { datasource: any, datatableViewMode: ABW_MAT_DATATABLE_VIEWMODE, selection?: any, primaryKey?: string, label?: string },
    ) {
        this.datas = data.datasource;
        this.datatableViewMode = data.datatableViewMode;
        this.selection = data.selection;
        this.primaryKey = data.primaryKey;
        this.label = data.label || '';
    } 
    
    ngOnInit() {
    }

    ngAfterViewInit() {
        this._cdf.detectChanges();
        setTimeout(() => this.loading = true, 100);
    }


    dismiss(): void {
        this.dialogRef.close();
    }

    onSelection(selection: any) {
        this.dialogRef.close(selection);
    }
}